/*
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-03-24 16:07:46
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-11 10:14:08
 */
import Vue from "vue";
import axios from "axios";
import store from "@/store";
import global from "@/config/global";
import website from "@/utils/website";
import { Session, Local } from "@/utils/storage";

import { Message, MessageBox } from "element-ui";
import maintenance from "@/utils/maintenance";

// create an axios instance
const request = axios.create({
  baseURL: global.baseApi, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // request timeout
});

// request interceptor
request.interceptors.request.use(
  (config) => {
    if (
      window.sessionStorage.getItem("token") &&
      config.url.indexOf("auth/oauth2/token") == -1 &&
      config.url.indexOf("auth/token/check_token") == -1
    ) {
      config.headers["Authorization"] = window.sessionStorage.getItem("token");
    } else if (
      config.url.indexOf("auth/oauth2/token") != -1 ||
      config.url.indexOf("auth/token/check_token") != -1
    ) {
      const basicAuth = "Basic " + window.btoa(website.formLoginClient);
      config.headers["Authorization"] = basicAuth;
    }
    if (config.url.indexOf("admin/tenant/list") != -1) {
      config.headers["TENANT-ID"] = "1";
    } else {
      config.headers["TENANT-ID"] = window.sessionStorage.getItem("tenantId"); //补充租户id
    }

    //需要模拟数据的地方
    if (config.params && config.params.env && config.params.env == "dev") {
      config.headers["env"] = "dev"; //补充租户id
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// HTTPresponse拦截
request.interceptors.response.use(
  (res) => {
    const status = Number(res.status) || 200;
    if (status == 423) {
      const message = '"演示环境，仅供预览"';
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    } else if (status == 424) {
      MessageBox.confirm("登录状态已过期，请点击重新登录", "系统提示", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Session.clear(); // 清除浏览器全部临时缓存
        window.location.href = "/"; // 去登录页
      });
    } else if (status !== 200) {
      Message({ message: message, type: "error" });
      return Promise.reject(new Error(message));
    } else {
      if (
        res.data.code == 0 ||
        res.config.url == "/auth/oauth2/token" ||
        res.config.url == "easyapp/pages/checkPull"
      ) {
        return res.data;
      } else {
        const message = res.data.msg;
        Message({
          message: message,
          type: "error",
        });
        return Promise.reject(new Error(message));
      }
    }
  },
  (error) => {
    const status = error.response?.status;
    const errorData = error.response?.data || {};
    const errorMsg = errorData.message || errorData.msg || "";

    if ([502, 503, 599].includes(status)) {
      const redirectMsg =
        errorData.message || errorData.msg || errorMsg || "系统正在维护中";

      // 先校验 ops.json 是否真正处于维护状态
      axios
        .get(maintenance.getMaintenanceUrl(), { timeout: 5000 })
        .then((opsRes) => {
          const opsData = opsRes && opsRes.data;
          const isMaintenance =
            opsData &&
            ((opsData.code && [502, 503, 599].includes(opsData.code)) ||
              opsData.status === true);

          if (isMaintenance) {
            localStorage.setItem(maintenance.STORAGE_KEY, "true");
            maintenance.redirectToMaintenance(redirectMsg);
          } else {
            localStorage.removeItem(maintenance.STORAGE_KEY);
          }
        })
        .catch(() => {
          // ops.json 请求失败时降级：按原逻辑跳转维护页
          localStorage.setItem(maintenance.STORAGE_KEY, "true");
          maintenance.redirectToMaintenance(redirectMsg);
        });

      return Promise.reject(new Error(errorMsg));
    }

    if (status == 424) {
      window._ws && window._ws?.destroy();
      let errorNumber = Local.get("errorNumber");

      // 避免多次重定向的标志
      const isAlreadyRedirecting = Local.get("isRedirecting");

      if (isAlreadyRedirecting) return;
      Local.set("isRedirecting", { content: true, type: "session" });

      // 统一处理重定向逻辑
      const handleRedirect = () => {
        Session.clear(); // 清除浏览器全部临时缓存
        window.location.href = "/"; // 去登录页
      };

      if ((errorNumber && errorNumber.number === 0) || !errorNumber) {
        Local.set("errorNumber", {
          content: { number: 1, name: "424" },
          type: "session",
        });
        MessageBox.confirm("登录状态已过期，请点击重新登录", "系统提示", {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(handleRedirect)
          .catch(handleRedirect);
      } else {
        Session.clear(); // 清除浏览器全部临时缓存
        window.location.href = "/"; // 去登录页
      }

      // 防止Promise链继续执行
      return Promise.reject("");
    } else {
      if (errorData.msg || errorMsg) {
        Message({ message: errorData.msg || errorMsg, type: "error" });
        return Promise.reject(new Error(errorData.msg || errorMsg));
      }
    }
  },
);

export default request;
